import { CityStructure } from '@/core/Game/constants'
import type { Grid, GridTile } from '@/core/Game/types'

import { TileKey } from '../constants'
import { tileStore } from '../libs/TileStore'

function countNeighborRoads(neighborGrid: Grid): number {
  return (
    Number(neighborGrid.at(0)?.at(1)?.[0].structure === CityStructure.Road) +
    Number(neighborGrid.at(1)?.at(0)?.[0].structure === CityStructure.Road) +
    Number(neighborGrid.at(1)?.at(2)?.[0].structure === CityStructure.Road) +
    Number(neighborGrid.at(2)?.at(1)?.[0].structure === CityStructure.Road)
  )
}

function get3NeighborRoadsRotation(neighborGrid: Grid): 0 | 90 | 180 | 270 {
  if (neighborGrid.at(0)?.at(1)?.[0].structure === CityStructure.Road) {
    if (neighborGrid.at(1)?.at(0)?.[0].structure === CityStructure.Road) {
      if (neighborGrid.at(2)?.at(1)?.[0].structure === CityStructure.Road) {
        return 180
      }

      return 270
    }

    return 0
  }

  return 90
}

function get2NeighborRoadsRotation(neighborGrid: Grid): 0 | 90 | 180 | 270 {
  if (neighborGrid.at(0)?.at(1)?.[0].structure === CityStructure.Road) {
    if (neighborGrid.at(1)?.at(2)?.[0].structure === CityStructure.Road) {
      return 0
    }

    return 270
  }

  if (neighborGrid.at(1)?.at(2)?.[0].structure === CityStructure.Road) {
    return 90
  }

  return 180
}

interface TileProps {
  neighborGrid: Grid
  value: GridTile
}
export function getTileFromCell({
  neighborGrid,
  value,
}: Readonly<TileProps>): [image: HTMLImageElement, angle: number] {
  if (value[0].structure === CityStructure.None) {
    return [tileStore.get(TileKey.Meadow), 0]
  }

  if (value[0].structure === CityStructure.House) {
    return [tileStore.get(TileKey.HousingLow), 0]
  }

  if (value[0].structure === CityStructure.Road) {
    const neighborRoadsCount = countNeighborRoads(neighborGrid)

    if (neighborRoadsCount === 4) {
      return [tileStore.get(TileKey.RoadIntersection), 0]
    }

    if (neighborRoadsCount === 3) {
      return [tileStore.get(TileKey.RoadNorthEastSouth), get3NeighborRoadsRotation(neighborGrid)]
    }

    if (neighborRoadsCount === 2) {
      if (
        neighborGrid.at(0)?.at(1)?.[0].structure === CityStructure.Road &&
        neighborGrid.at(2)?.at(1)?.[0].structure === CityStructure.Road
      ) {
        return [tileStore.get(TileKey.RoadNorthSouth), 0]
      }

      if (
        neighborGrid.at(1)?.at(0)?.[0].structure === CityStructure.Road &&
        neighborGrid.at(1)?.at(2)?.[0].structure === CityStructure.Road
      ) {
        return [tileStore.get(TileKey.RoadNorthSouth), 90]
      }

      return [tileStore.get(TileKey.RoadNorthEast), get2NeighborRoadsRotation(neighborGrid)]
    }

    if (
      neighborGrid.at(1)?.at(0)?.[0].structure === CityStructure.Road ||
      neighborGrid.at(1)?.at(2)?.[0].structure === CityStructure.Road
    ) {
      return [tileStore.get(TileKey.RoadNorthSouth), 90]
    }

    return [tileStore.get(TileKey.RoadNorthSouth), 0]
  }

  throw new Error(`Invalid tile value: ${value}.`)
}
